import * as R from 'ramda'
import { reducer as search } from 'redux-search'

import combineReducers from 'utils/redux/combineReducers'
import photoList from './photoList'
import projectReducers from './projectReducers'
import loaderReducers from './loaderReducers'
import projectFiltersReducers from './projectFiltersReducers'
import taskFilters from './taskFilters'
import leaseFilters from './leaseFilters'
import tenantsFilters from './tenantsFilters'
import repairmenFilters from './repairmenFilters'
import agentsFilters from './agentsFilters'
import actionBarReducers from './actionBarReducers'
import data from './data'
import attachments from './attachments'
import attachmentOverlay from './attachmentOverlay'
import newComment from './newComment'
import newProject from './newProject'
import newTenants from './newTenants'
import mobile from './mobileReducers'
import login from './login'
import yelp from './yelp'
import popup from './popup'
import projectForm from './projectForm'
import repairmenSelect from './repairmenSelect'
import propertyFilters from './propertyFilters'
import notifications from './notifications'
import transactionsFilters from './transactionsFilters'
import routing from './routing.landlord'
import mode from './mode'
import prompt, { meta } from './prompt'
import screenSize from './screenSize'
import time from './time'
import currentFilters from './filters'
import sections from './sections'
import sort from './sort'
import commentBuffer from './commentBuffer'
import selectedRows from './selectedRows'
import session from './session'
import finance from './finance'
import tooltips from './tooltips'
import error from './error'
import accordion from './accordion'
import selectedProperty from './selectedProperty'
import scrollTop from './scrollTop'
import shouldScroll from './shouldScroll'

let combined = combineReducers({
	photoList
  , data
  , session
  , error
  , sections
  , routing
  , attachments
  , attachmentOverlay
  , newComment
  , mode
  , prompt
  , screenSize
  , time
  , projectReducers
  , loaderReducers
  , projectFiltersReducers
  , propertyFilters
  , actionBarReducers
  , newProject
  , taskFilters
  , leaseFilters
  , tenantsFilters
  , repairmenFilters
  , agentsFilters
  , newTenants
  , login
  , mobile
  , notifications
  , transactionsFilters
  , popup
  , projectForm
  , repairmenSelect
  , currentFilters
  , sort
  , commentBuffer
  , selectedRows
  , search
  , finance
	, tooltips
	, accordion
	, selectedProperty
	, scrollTop
	, shouldScroll
})

export default meta(combined)



// WEBPACK FOOTER //
// ./src/reducers/index.landlord.js